<template>
  <v-layout row>
    <v-flex xs12 sm12 offset-sm>
      <v-card>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="text-xs-center">Interest Account</v-toolbar-title>
          <v-spacer></v-spacer>

          <v-card-actions class="justify-center">
            <v-btn 
              @click.stop="dialog = true"
              class="primary white--text">
              <v-icon>close</v-icon>
            </v-btn>  
          </v-card-actions>
        </v-toolbar>
      </v-card>
    

    <v-data-table
        :headers="headers"
        :items="filteredInvoices"
        class="elevation-1"
    >
       <template slot="items" slot-scope="props">
          <!-- <td class="text-xs-left nowrap"><b>{{ props.item.buyerName }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.propName }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.buyerId }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.mobile }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.village }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.block }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.tehsil }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.district }}</b></td> -->

          <td class="text-xs-left nowrap"><b>{{ props.item['.key'] }}</b></td>
          <td class="text-xs-left nowrap"><b>{{ props.item.date }}</b></td>
          <!-- <td class="text-xs-left nowrap"><b>{{ props.item.closedDate || null }}</b></td>-->
          <td class="text-xs-left nowrap"><b>{{ props.item.firmName }}</b></td>
          <!-- <td class="text-xs-left nowrap"><b>{{ props.item.paymentType }}</b></td> -->
          <td class="nowrap"><b>{{ props.item.rate }} </b>%</td>
          <!-- <td class="nowrap"><b>{{ props.item.daysLeft }} days</b></td> -->
          <td class="nowrap"><b>₹ {{ props.item.totalAmount }}</b></td>
          <!-- <td class="nowrap"><b>{{ props.item.duration }} days</b></td> -->
          <td class="nowrap"><b>₹ {{ props.item.interestValue }}</b></td>
          <td class="nowrap"><b>₹ {{ props.item.totalValue }}</b></td>
          <!-- <td class="nowrap"><b>{{ props.item.status }}</b></td> -->
        </template>
    </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const mapGlobalGetters = createNamespacedHelpers('Global')['mapGetters']

export default {
  // name: 'Firms',
  data () {
    return {
        headers: [
        // { text: 'Buyer Name', sortable: false, value: 'buyerName' },
        // { text: 'Father Name', sortable: false, value: 'propName' },
        // { text: 'Buyer ID', sortable: false, value: 'buyerId' },
        // { text: 'Village', sortable: false, value: 'village' },
        // { text: 'Block', sortable: false, value: 'block' },
        // { text: 'Tehsil', sortable: false, value: 'tehsil' },
        // { text: 'District', sortable: false, value: 'district' },
        { text: 'Date', sortable: false, value: 'date' },
        { text: 'Invoice Id', sortable: false, value: 'key' },
        // { text: 'Item Type', sortable: false, value: 'itemType' },
        // { text: 'Item SubType', sortable: false, value: 'itemSubType' },        
        // { text: 'Closed Date', sortable: false, value: 'closedDate' },
        { text: 'Firm', sortable: false, value: 'firmName' },
        // { text: 'Payment Type', sortable: false, value: 'paymentType' },
        { text: 'Rate %', sortable: false, value: 'rate' },
        // { text: 'Days Left', sortable: true, value: 'daysLeft' },
        { text: 'Principal Value', sortable: false, value: 'totalAmount' },
        // { text: 'Duration (in Days)', sortable: false, value: 'duration' },
        { text: 'Interest Value', sortable: false, value: 'interestValue' },
        { text: 'Total Value', sortable: false, value: 'totalValue' },
        // { text: 'Status', sortable: false, value: 'principalValue' },
        // { text: 'Mobile', sortable: false, value: 'mobile' },
        //{ text: '', value: 'name', sortable: false }
      ],
      firms: {},
      buyerById: {}
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/Informations/Interestsheet/index.vue